import React from 'react'
import './Right_Side_Content.css'
import Spiritual_Dashboard from './spiritual_dashboard/Spiritual_Dashboard'
import Share_Experience from './share_experience/Share_Experience'

const Right_Side_Content = () => {
  return (
    <div className='Right_Side_Content'>
        <Spiritual_Dashboard/>
        <Share_Experience/>
    </div>
  )
}

export default Right_Side_Content
